module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIRECTIVES_PACK.e7d2a07a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIRECTIVES_PACK.png
// module id = 1278
// module chunks = 16